import { ListingTable } from "components/listing";
import { StackedBarChart } from "components/charts";
import React, { useCallback, useMemo } from "react";
import { parseBytesTo } from "utils/parseBytesTo";

export function AreaStorage({ areaStorage, loading }) {
    const storagePerAreaChartData = useMemo(() => {
        if (loading || !areaStorage) {
            return [];
        }

        return areaStorage
            .filter(area => area.totalSize > 0)
            .map(area => ({
                id: area.areaId,
                label: area.areaName,
                value: area.totalSize,
                onRender: (value) => parseBytesTo(value).auto()
            }));
    }, [areaStorage, loading]);

    const storageAreaDocumentTypes = useMemo(() => {
        if (loading || !areaStorage) {
            return [];
        }

        return areaStorage
            .filter(area => area.totalSize > 0)
            .reduce((acc, current) => {
                return [
                    ...acc,
                    {
                        title: current.areaName,
                        areaData: [
                            current.areaName,
                            current.numberOfDocuments,
                            parseBytesTo(current.totalSize).auto(),
                            current.percentageOfTotal + '%'
                        ],
                        data: current.documentTypes.map(docType => ([
                            docType.documentTypeName,
                            docType.numberOfDocuments,
                            parseBytesTo(docType.totalSize).auto(),
                            docType.percentageOfArea + '%',
                            docType.percentageOfTotal + '%'
                        ]))
                    }
                ]
            }, []);
    }, [areaStorage, loading]);

    const StorageTable = useCallback(({ title, dataA, dataB, loadingData }) => {

        const tableAreaHeaders = ['Area', 'Documents', 'Total Size', '% of Total'];
        const tableFilesHeaders = ['Upload', 'Documents', 'Total Size', '% of Area', '% of Total'];

        return (
            <div className='spacer-top'>
                <h3>{title}</h3>
                <ListingTable
                    id='storage-area-table'
                    headers={tableAreaHeaders}
                    data={dataA}
                    totalRecordCount={dataA.length}
                    pageable={false}
                    showPerPage={false}
                    shrinkLastColumn={false}
                    loadingData={loadingData}
                    columnWidths={['40%', '20%', '27%', '13%']}
                />
                <ListingTable
                    id='storage-files-table'
                    headers={tableFilesHeaders}
                    data={dataB}
                    totalRecordCount={dataB.length}
                    pageable={false}
                    showPerPage={false}
                    shrinkLastColumn={false}
                    loadingData={loadingData}
                    columnWidths={['40%', '20%', '14%', '13%', '13%']}
                />
            </div>
        )
    }, []);

    return (
        <>
            <div className='spacer-top'>
                <StackedBarChart title="Storage by Area" items={storagePerAreaChartData} loading={loading} noDataMessage="No documents have been uploaded."/>
            </div>

            {storageAreaDocumentTypes.map(area => (
                <StorageTable key={area.title} title={area.title + " Documents"} dataA={[area.areaData]} dataB={area.data} loadingData={false} />
            ))}
        </>
    )
}